// client/src/routes/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, rolesPermitidos = [] }) => {
  const { usuario, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si es SuperAdmin, tiene acceso total (bypass de roles)
  if (usuario?.isSuperAdmin) {
    return children;
  }

  // Si es Usuario normal, validar roles
  if (rolesPermitidos.length > 0 && !rolesPermitidos.includes(usuario?.rol)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
